import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import Button from "../../../Components/Button";

const CancellationReasonForm = ({
    register,
    handleSubmit,
    errors,
    control,
    onSubmit,
    isLoading,
    isEdit = false,
}) => {
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {isEdit && <input type="hidden" {...register("id")} />}
            <div className="pform-card">
                <div className="pform-card__head">
                    <span className="pform-card__step">1</span>
                    <div>
                        <h2 className="pform-card__title">Reason Details</h2>
                        <p className="pform-card__desc">Write a clear cancellation reason for the app</p>
                    </div>
                </div>

                <div className="pform-field">
                    <label className="cms-field-label">
                        Cancellation Reason <span className="text-danger">*</span>
                    </label>
                    <textarea
                        className={`cms-textarea ${errors.reason ? "is-invalid" : ""}`}
                        rows={4}
                        placeholder="Enter reason for cancellation..."
                        {...register("reason", { required: "Reason is required" })}
                    />
                    {errors.reason && (
                        <span className="cms-field-error">{errors.reason.message}</span>
                    )}
                </div>
            </div>

            <div className="pform-card">
                <div className="pform-card__head">
                    <span className="pform-card__step">2</span>
                    <div>
                        <h2 className="pform-card__title">Audience & Visibility</h2>
                        <p className="pform-card__desc">Choose who sees this reason and whether it&apos;s active</p>
                    </div>
                </div>

                <div className="pform-field">
                    <label className="cms-field-label">Who is this for?</label>
                    <Controller
                        name="userType"
                        control={control}
                        render={({ field }) => (
                            <div className="pform-type-pills">
                                <label className={`pform-type-pill ${field.value === "user" ? "is-selected" : ""}`}>
                                    <input type="radio" value="user" checked={field.value === "user"} onChange={() => field.onChange("user")} />
                                    <span className="pform-type-pill__inner">
                                        <span className="pform-type-pill__icon">
                                            <i className="fas fa-user" />
                                        </span>
                                        <span className="pform-type-pill__label">User</span>
                                        <span className="pform-type-pill__hint">Booking cancellations</span>
                                    </span>
                                </label>
                                <label className={`pform-type-pill pform-type-pill--driver ${field.value === "driver" ? "is-selected" : ""}`}>
                                    <input type="radio" value="driver" checked={field.value === "driver"} onChange={() => field.onChange("driver")} />
                                    <span className="pform-type-pill__inner">
                                        <span className="pform-type-pill__icon">
                                            <i className="fas fa-truck" />
                                        </span>
                                        <span className="pform-type-pill__label">Driver</span>
                                        <span className="pform-type-pill__hint">Driver-side cancellations</span>
                                    </span>
                                </label>
                            </div>
                        )}
                    />
                </div>

                <div className="pform-field">
                    <label className="cms-field-label">Status</label>
                    <Controller
                        name="status"
                        control={control}
                        render={({ field }) => (
                            <div className={`pform-status-row ${field.value === "true" ? "is-active" : ""}`}>
                                <div className="pform-status-row__text">
                                    <strong>{field.value === "true" ? "Active" : "Inactive"}</strong>
                                    <span>
                                        {field.value === "true"
                                            ? "Visible in the cancellation list"
                                            : "Hidden from users and drivers"}
                                    </span>
                                </div>
                                <select
                                    className="cms-input"
                                    style={{ width: "auto", minWidth: "120px", padding: "0.55rem 0.75rem" }}
                                    value={field.value}
                                    onChange={field.onChange}
                                >
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                </select>
                            </div>
                        )}
                    />
                </div>
            </div>

            <div className="pform-footer">
                <Link to="/cancellation-management" className="cms-btn-cancel">
                    Cancel
                </Link>
                <Button className="cms-btn-save" type="submit" loading={isLoading}>
                    {isEdit ? "Update Reason" : "Save Reason"}
                </Button>
            </div>
        </form>
    );
};

export default CancellationReasonForm;
